{
  "three-acts": {
    "name": "三幕结构",
    "summary": "铺垫、对抗与解决：大多数小说和电影共有的结构。",
    "bestFor": "适合任何类型，以及希望保持简单的初稿。",
    "metaTitle": "三幕结构故事模板 — Musael",
    "metaDescription": "铺垫、对抗与解决：大多数小说和电影共有的三幕结构。适合任何类型，以及希望保持简单的初稿。",
    "acts": [
      {
        "title": "第 I 幕：铺垫",
        "synopsis": "主角是谁、想要什么，以及哪件事结束了原本的日常生活。",
        "chapters": [
          {
            "title": "日常世界",
            "synopsis": "主角身处熟悉的环境，带着故事将要考验的愿望和缺点。",
            "scenes": [
              {
                "title": "开场画面",
                "synopsis": "在一切改变之前，呈现主角的一个瞬间。"
              },
              {
                "title": "故事钩子",
                "synopsis": "一件小而古怪的事，预示麻烦将至。"
              }
            ]
          },
          {
            "title": "触发事件",
            "synopsis": "主角无法忽视的事件。",
            "scenes": [
              {
                "title": "诱发事件",
                "synopsis": "问题出现了，而且不会自行消失。"
              },
              {
                "title": "犹豫",
                "synopsis": "主角迟疑不决，我们看见其可能失去什么。"
              }
            ]
          },
          {
            "title": "跨越门槛",
            "synopsis": "主角下定决心，再也无法轻易回头。",
            "scenes": [
              {
                "title": "决定",
                "synopsis": "主角选择行动，离开熟悉的一切。"
              }
            ]
          }
        ]
      },
      {
        "title": "第 II 幕：对抗",
        "synopsis": "主角不断尝试、失败和学习，而利害关系持续升级。",
        "chapters": [
          {
            "title": "不断加码",
            "synopsis": "新的规则、盟友与敌人；最初的胜利也要付出代价。",
            "scenes": [
              {
                "title": "第一次考验",
                "synopsis": "主角接触新世界，却有部分理解错了。"
              },
              {
                "title": "盟友与敌人",
                "synopsis": "谁在帮助，谁在阻挠，原因是什么。"
              }
            ]
          },
          {
            "title": "故事中点",
            "synopsis": "一次逆转，改变故事的核心意义。",
            "scenes": [
              {
                "title": "中点",
                "synopsis": "一场虚假的胜利或失败；主角不再只是应对，而开始主动推动局面。"
              }
            ]
          },
          {
            "title": "一切崩塌",
            "synopsis": "对手步步逼近，主角的缺点让其付出沉重代价。",
            "scenes": [
              {
                "title": "压力收紧",
                "synopsis": "每个计划都遭遇阻力，关系出现裂痕。"
              },
              {
                "title": "一切尽失",
                "synopsis": "最低谷：目标仿佛永远无法实现。"
              }
            ]
          }
        ]
      },
      {
        "title": "第 III 幕：解决",
        "synopsis": "主角发生改变，面对最后的考验，新的日常由此开始。",
        "chapters": [
          {
            "title": "故事高潮",
            "synopsis": "凭借第 II 幕学到的道理，赢下最后的对决。",
            "scenes": [
              {
                "title": "最后的计划",
                "synopsis": "主角汇集所学，做出最后一次尝试。"
              },
              {
                "title": "高潮",
                "synopsis": "决定胜负的对决。"
              }
            ]
          },
          {
            "title": "新的日常",
            "synopsis": "主角和世界分别发生了什么变化。",
            "scenes": [
              {
                "title": "收尾画面",
                "synopsis": "呼应开场画面，展现主角走过了多远。"
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "英雄之旅",
    "summary": "从冒险召唤到返回家园的十二个阶段，分为启程、历练与归来。",
    "bestFor": "适合奇幻、冒险与探寻故事。",
    "metaTitle": "英雄之旅故事模板 — Musael",
    "metaDescription": "从冒险召唤到返回家园的十二个阶段，分为启程、历练与归来。适合奇幻、冒险与探寻故事。",
    "acts": [
      {
        "title": "启程",
        "synopsis": "主角离开已知的世界。",
        "chapters": [
          {
            "title": "日常世界",
            "synopsis": "冒险前的主角：家、习惯，以及缺少的东西。",
            "scenes": [
              {
                "title": "日常世界",
                "synopsis": "冒险前的主角：家、习惯，以及缺少的东西。"
              }
            ]
          },
          {
            "title": "冒险召唤",
            "synopsis": "一个挑战或消息打破日常世界。",
            "scenes": [
              {
                "title": "冒险召唤",
                "synopsis": "一个挑战或消息打破日常世界。"
              }
            ]
          },
          {
            "title": "拒绝召唤",
            "synopsis": "恐惧或责任让主角止步。",
            "scenes": [
              {
                "title": "拒绝召唤",
                "synopsis": "恐惧或责任让主角止步。"
              }
            ]
          },
          {
            "title": "遇见导师",
            "synopsis": "有人提供建议、训练或礼物。",
            "scenes": [
              {
                "title": "遇见导师",
                "synopsis": "有人提供建议、训练或礼物。"
              }
            ]
          },
          {
            "title": "跨越第一道门槛",
            "synopsis": "主角进入非日常的世界。",
            "scenes": [
              {
                "title": "跨越第一道门槛",
                "synopsis": "主角进入非日常的世界。"
              }
            ]
          }
        ]
      },
      {
        "title": "历练",
        "synopsis": "非日常世界中的种种考验，以及那场重大磨难。",
        "chapters": [
          {
            "title": "考验、盟友与敌人",
            "synopsis": "主角学习新世界的规则。",
            "scenes": [
              {
                "title": "考验、盟友与敌人",
                "synopsis": "主角学习新世界的规则。"
              }
            ]
          },
          {
            "title": "接近最深的洞穴",
            "synopsis": "为核心危险做准备。",
            "scenes": [
              {
                "title": "接近最深的洞穴",
                "synopsis": "为核心危险做准备。"
              }
            ]
          },
          {
            "title": "重大磨难",
            "synopsis": "一场生死危机；主角内心的某部分死去。",
            "scenes": [
              {
                "title": "重大磨难",
                "synopsis": "一场生死危机；主角内心的某部分死去。"
              }
            ]
          },
          {
            "title": "奖赏",
            "synopsis": "主角获得宝藏、知识或和解。",
            "scenes": [
              {
                "title": "奖赏",
                "synopsis": "主角获得宝藏、知识或和解。"
              }
            ]
          }
        ]
      },
      {
        "title": "归来",
        "synopsis": "归途、最后一次考验，以及主角带回的东西。",
        "chapters": [
          {
            "title": "返回之路",
            "synopsis": "主角踏上归途，往往还被人追赶。",
            "scenes": [
              {
                "title": "返回之路",
                "synopsis": "主角踏上归途，往往还被人追赶。"
              }
            ]
          },
          {
            "title": "重生",
            "synopsis": "最后一次考验，将此前所学全部用上。",
            "scenes": [
              {
                "title": "重生",
                "synopsis": "最后一次考验，将此前所学全部用上。"
              }
            ]
          },
          {
            "title": "携灵药归来",
            "synopsis": "主角带着改变回家，也带回可与他人分享的东西。",
            "scenes": [
              {
                "title": "携灵药归来",
                "synopsis": "主角带着改变回家，也带回可与他人分享的东西。"
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "十五节拍大纲",
    "summary": "编剧使用的节拍表，将十五个转折点分布在三幕中。",
    "bestFor": "适合结构紧凑、转折清晰的商业故事。",
    "metaTitle": "十五节拍故事大纲模板 — Musael",
    "metaDescription": "编剧使用的节拍表，将十五个转折点分布在三幕中。适合结构紧凑、转折清晰的商业故事。",
    "acts": [
      {
        "title": "第 I 幕",
        "synopsis": "原本的世界，以及离开它的选择。",
        "chapters": [
          {
            "title": "开场画面",
            "synopsis": "故事开始前的主角与世界。",
            "scenes": [
              {
                "title": "开场画面",
                "synopsis": "故事开始前的主角与世界。"
              }
            ]
          },
          {
            "title": "点明主题",
            "synopsis": "有人说出故事真正的主题，主角尚未领会。",
            "scenes": [
              {
                "title": "点明主题",
                "synopsis": "有人说出故事真正的主题，主角尚未领会。"
              }
            ]
          },
          {
            "title": "铺垫",
            "synopsis": "主角的生活、身边的人，以及需要改变的问题。",
            "scenes": [
              {
                "title": "铺垫",
                "synopsis": "主角的生活、身边的人，以及需要改变的问题。"
              }
            ]
          },
          {
            "title": "催化事件",
            "synopsis": "推动故事开始运转的事件。",
            "scenes": [
              {
                "title": "催化事件",
                "synopsis": "推动故事开始运转的事件。"
              }
            ]
          },
          {
            "title": "犹豫",
            "synopsis": "主角不确定该怎么做。",
            "scenes": [
              {
                "title": "犹豫",
                "synopsis": "主角不确定该怎么做。"
              }
            ]
          },
          {
            "title": "进入第二幕",
            "synopsis": "主角选择一条新路。",
            "scenes": [
              {
                "title": "进入第二幕",
                "synopsis": "主角选择一条新路。"
              }
            ]
          }
        ]
      },
      {
        "title": "第 II 幕",
        "synopsis": "兑现故事设定的期待，然后走向坠落。",
        "chapters": [
          {
            "title": "副线故事",
            "synopsis": "承载主题的次要故事，通常是一段关系。",
            "scenes": [
              {
                "title": "副线故事",
                "synopsis": "承载主题的次要故事，通常是一段关系。"
              }
            ]
          },
          {
            "title": "趣味与游戏",
            "synopsis": "兑现设定：呈现读者为之而来的内容。",
            "scenes": [
              {
                "title": "趣味与游戏",
                "synopsis": "兑现设定：呈现读者为之而来的内容。"
              }
            ]
          },
          {
            "title": "中点",
            "synopsis": "一场虚假的胜利或失败，让利害关系升级。",
            "scenes": [
              {
                "title": "中点",
                "synopsis": "一场虚假的胜利或失败，让利害关系升级。"
              }
            ]
          },
          {
            "title": "敌人逼近",
            "synopsis": "内心有疑虑，外部有压力。",
            "scenes": [
              {
                "title": "敌人逼近",
                "synopsis": "内心有疑虑，外部有压力。"
              }
            ]
          },
          {
            "title": "一切尽失",
            "synopsis": "与中点相反的状态：最深的低谷。",
            "scenes": [
              {
                "title": "一切尽失",
                "synopsis": "与中点相反的状态：最深的低谷。"
              }
            ]
          },
          {
            "title": "灵魂的黑夜",
            "synopsis": "主角哀悼所失，并从中找到教训。",
            "scenes": [
              {
                "title": "灵魂的黑夜",
                "synopsis": "主角哀悼所失，并从中找到教训。"
              }
            ]
          }
        ]
      },
      {
        "title": "第 III 幕",
        "synopsis": "将学到的道理付诸行动。",
        "chapters": [
          {
            "title": "进入第三幕",
            "synopsis": "来自副线的新想法打开一条路。",
            "scenes": [
              {
                "title": "进入第三幕",
                "synopsis": "来自副线的新想法打开一条路。"
              }
            ]
          },
          {
            "title": "终局",
            "synopsis": "主角修复破碎的一切，自己也彻底改变。",
            "scenes": [
              {
                "title": "终局",
                "synopsis": "主角修复破碎的一切，自己也彻底改变。"
              }
            ]
          },
          {
            "title": "结束画面",
            "synopsis": "故事之后的世界，与开场画面相呼应。",
            "scenes": [
              {
                "title": "结束画面",
                "synopsis": "故事之后的世界，与开场画面相呼应。"
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "七点结构",
    "summary": "从结局倒推：钩子、转折、压力点、中点与解决。",
    "bestFor": "适合先想到结局的作者。",
    "metaTitle": "七点结构故事模板 — Musael",
    "metaDescription": "从结局倒推故事，安排钩子、转折、压力点、中点与解决。适合先想到结局的作者。",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "钩子",
            "synopsis": "起始状态，与结局的状态相反。",
            "scenes": [
              {
                "title": "钩子",
                "synopsis": "起始状态，与结局的状态相反。"
              }
            ]
          },
          {
            "title": "情节转折 1",
            "synopsis": "冲突开始，主角被推动着采取行动。",
            "scenes": [
              {
                "title": "情节转折 1",
                "synopsis": "冲突开始，主角被推动着采取行动。"
              }
            ]
          },
          {
            "title": "压力点 1",
            "synopsis": "反派施加压力，主角必须行动。",
            "scenes": [
              {
                "title": "压力点 1",
                "synopsis": "反派施加压力，主角必须行动。"
              }
            ]
          },
          {
            "title": "中点",
            "synopsis": "主角从被动应对转为主动行动。",
            "scenes": [
              {
                "title": "中点",
                "synopsis": "主角从被动应对转为主动行动。"
              }
            ]
          },
          {
            "title": "压力点 2",
            "synopsis": "局势严重恶化，计划失败。",
            "scenes": [
              {
                "title": "压力点 2",
                "synopsis": "局势严重恶化，计划失败。"
              }
            ]
          },
          {
            "title": "情节转折 2",
            "synopsis": "主角获得取胜所需的最后一块拼图。",
            "scenes": [
              {
                "title": "情节转折 2",
                "synopsis": "主角获得取胜所需的最后一块拼图。"
              }
            ]
          },
          {
            "title": "解决",
            "synopsis": "结束时的状态，也是对开场钩子的回应。",
            "scenes": [
              {
                "title": "解决",
                "synopsis": "结束时的状态，也是对开场钩子的回应。"
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "起承转合",
    "summary": "以转折而非冲突为核心的四段结构。",
    "bestFor": "适合文学小说、短篇，以及以人物为中心的安静故事。",
    "metaTitle": "起承转合故事模板 — Musael",
    "metaDescription": "以转折而非冲突为核心的四段结构。适合文学小说、短篇，以及以人物为中心的安静故事。",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "起：引入",
            "synopsis": "平静地介绍人物和他们的世界。",
            "scenes": [
              {
                "title": "引入",
                "synopsis": "谁、在哪里，以及日常是什么模样。"
              }
            ]
          },
          {
            "title": "承：发展",
            "synopsis": "局面逐渐深入，尚未发生转折。",
            "scenes": [
              {
                "title": "发展",
                "synopsis": "我们更了解人物，一些小事悄然变化。"
              }
            ]
          },
          {
            "title": "转：转折",
            "synopsis": "一个出人意料的元素，改变我们看待一切的方式。",
            "scenes": [
              {
                "title": "转折",
                "synopsis": "新的事物出现，表面上似乎与此前无关。"
              }
            ]
          },
          {
            "title": "合：融会",
            "synopsis": "各部分汇聚，形成新的理解。",
            "scenes": [
              {
                "title": "融会",
                "synopsis": "转折与故事相遇，意义随之改变。"
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "推理",
    "summary": "一桩罪案、一场追查线索与误导线索的调查，以及对读者公平的揭晓。",
    "bestFor": "适合犯罪小说、侦探小说和轻松推理。",
    "metaTitle": "推理故事模板 — Musael",
    "metaDescription": "从罪案开始，追查线索与误导线索，最终公平地揭晓真相。适合犯罪小说、侦探小说和轻松推理。",
    "acts": [
      {
        "title": "罪案",
        "synopsis": "有什么不对劲，必须有人查明原因。",
        "chapters": [
          {
            "title": "发现",
            "synopsis": "罪案或失踪事件。",
            "scenes": [
              {
                "title": "尸体",
                "synopsis": "罪案被发现，形成第一印象和最初的问题。"
              },
              {
                "title": "侦探",
                "synopsis": "谁来调查，以及此事为何对调查者重要。"
              }
            ]
          }
        ]
      },
      {
        "title": "调查",
        "synopsis": "线索、嫌疑人和误导线索。",
        "chapters": [
          {
            "title": "嫌疑人",
            "synopsis": "所有有动机、也有不在场证明的人。",
            "scenes": [
              {
                "title": "询问",
                "synopsis": "每个嫌疑人都有说谎的理由。"
              },
              {
                "title": "第一条线索",
                "synopsis": "一件稍后会变得重要的事实；对读者保持公平。"
              }
            ]
          },
          {
            "title": "误导线索",
            "synopsis": "调查走向错误的方向。",
            "scenes": [
              {
                "title": "障眼法",
                "synopsis": "证据指向错误的人。"
              },
              {
                "title": "事态升级",
                "synopsis": "第二桩罪案或威胁，让利害关系升级。"
              }
            ]
          },
          {
            "title": "隐藏的真相",
            "synopsis": "侦探看见了始终摆在眼前的东西。",
            "scenes": [
              {
                "title": "缺失的拼图",
                "synopsis": "一个小细节，让此前的线索拼合起来。"
              }
            ]
          }
        ]
      },
      {
        "title": "真相揭晓",
        "synopsis": "答案，以及得到答案的代价。",
        "chapters": [
          {
            "title": "答案",
            "synopsis": "每条线索都得到解释。",
            "scenes": [
              {
                "title": "真相揭晓",
                "synopsis": "指出真凶，并说明推理过程。"
              },
              {
                "title": "余波",
                "synopsis": "正义或正义的缺席，以及侦探带走的东西。"
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "爱情",
    "summary": "两个人、让他们分离的阻碍，以及彼此选择所需的改变。",
    "bestFor": "适合任何背景下的爱情小说与恋爱故事。",
    "metaTitle": "爱情故事模板 — Musael",
    "metaDescription": "两个人、让他们分离的阻碍，以及彼此选择所需的改变。适合任何背景下的爱情小说与恋爱故事。",
    "acts": [
      {
        "title": "坠入爱河",
        "synopsis": "他们相遇、抗拒，然后开始动心。",
        "chapters": [
          {
            "title": "相遇",
            "synopsis": "初次相见，既有火花，也有阻碍。",
            "scenes": [
              {
                "title": "初见",
                "synopsis": "两位主角相遇，对方身上的某些东西触动了他们。"
              },
              {
                "title": "抗拒",
                "synopsis": "为什么这段关系行不通：目标、伤口或处境。"
              }
            ]
          },
          {
            "title": "逐渐靠近",
            "synopsis": "不得不待在一起，他们看见彼此真实的模样。",
            "scenes": [
              {
                "title": "偶然同行",
                "synopsis": "某种局面让他们保持接近。"
              },
              {
                "title": "第一个真实的瞬间",
                "synopsis": "窥见对方真正是谁。"
              }
            ]
          }
        ]
      },
      {
        "title": "怀疑",
        "synopsis": "先是投入，然后是将其打碎的恐惧。",
        "chapters": [
          {
            "title": "故事中点",
            "synopsis": "他们顺从自己的感受。",
            "scenes": [
              {
                "title": "投入",
                "synopsis": "一个吻、一次表白或一个承诺。"
              }
            ]
          },
          {
            "title": "裂痕",
            "synopsis": "旧伤或外界阻碍暂时占了上风。",
            "scenes": [
              {
                "title": "疑虑",
                "synopsis": "旧日的恐惧重新浮现。"
              },
              {
                "title": "分手",
                "synopsis": "他们分开，双方都确信自己是对的。"
              }
            ]
          }
        ]
      },
      {
        "title": "选择",
        "synopsis": "成长、一次郑重的示爱，以及共同的未来。",
        "chapters": [
          {
            "title": "在一起",
            "synopsis": "双方都改变到足以配得上对方。",
            "scenes": [
              {
                "title": "郑重的示爱",
                "synopsis": "其中一人冒上一切风险，证明自己已经改变。"
              },
              {
                "title": "从此幸福",
                "synopsis": "或者眼下幸福：这是他们选择的未来。"
              }
            ]
          }
        ]
      }
    ]
  }
}
